import type { ReactNode } from 'react';
import { LayoutProvider, useLayoutSlots } from './layoutContext';
import { BottomTabBar } from './BottomTabBar';
import { useAppStore } from '@app/store/useAppStore';
import { useKey } from '@app/hooks/useKey';
import { useMediaQuery } from '@app/hooks/useMediaQuery';
import styles from './MobileTabs.module.css';

function Body({ children }: { children: ReactNode }) {
  const { center, right } = useLayoutSlots();
  const keyId = useAppStore((s) => s.selectedKeyId);
  const key = useKey(keyId);
  const isLandscape = useMediaQuery('(orientation: landscape)');
  return (
    <div className={[styles.shell, isLandscape && styles.landscape].filter(Boolean).join(' ')}>
      {isLandscape && <BottomTabBar orientation="vertical" />}
      <div className={styles.column}>
        <header className={styles.header}>
          <span className={styles.brand}>Fretnaught</span>
          <span className={styles.pill}>{key ? key.displayName : '—'}</span>
        </header>
        <main className={styles.scroll} data-scroll-surface>
          {center && <section className={styles.section}>{center}</section>}
          {right && <section className={styles.section}>{right}</section>}
        </main>
        {!isLandscape && <BottomTabBar orientation="horizontal" />}
      </div>
      <div hidden>{children}</div>
    </div>
  );
}

export function MobileTabs({ children }: { children: ReactNode }) {
  return (
    <LayoutProvider>
      <Body>{children}</Body>
    </LayoutProvider>
  );
}
